import { combineReducers } from "redux";
import loginReducer from "./login/LoginSlice";
import CustomerServiceReducer from "./CustomerService/CustomerServiceSlice";
import customerReducer from "./CustomerProfile/CustomerInfoSlice";
import LoanApplicationReducer from "./LoanApplication/LoanApplicationSlice";
import UserDetailReducer from "./UserDetails/UserDetailsSlice";
import loanDetailReducer from "./LoanDetail/LoanDetailSlice";

export default combineReducers({
  login: loginReducer,
  customerInfo: customerReducer,
  userDetail: UserDetailReducer,
  CustomerService: CustomerServiceReducer,
  loanApplication: LoanApplicationReducer,
  loanDetail: loanDetailReducer,
});
